import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import Stack from "@mui/joy/Stack";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import { upload_image } from "../../../../reduxData/user/userAction";
import { useState } from "react";
import { useSelector } from "react-redux";
import { add_season_name } from "../../../../reduxData/user/userAction";

const PasswordCustomModel = ({
    open,
    setOpen,
    inputAttribute,
    setConfirmPassword,
    confPasswor,
    setInputAttribute,
    title = "Change Password",
    placeholder = "Enter name",
    error = "",
    onSubmit,
    data,
}) => {
    const token = useSelector((state) => state.auth.accessToken);
    // const handleAddSeason = async (img) => {
    //     if (!season) {
    //         setError("Season is required");
    //         return;
    //     }
    //     try {
    //         const payload = {
    //             code: season,
    //             season_ar: season_ar
    //         };
    //         const res = await add_season_name(token, payload);
    //         setSeason("");
    //         setSeason_ar("");
    //         setOpen(false);
    //         if (res) {
    //             setAddedFieldApi("season");
    //         }
    //     } catch (error) { }
    // };

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog>
                <DialogTitle>{title}</DialogTitle>
                <form>
                    <Stack spacing={2}>
                        <FormControl error={!!error}>
                            <div className="d-flex flex-column gap-1">
                                <p className="text text-black fs-6 m-0">Password</p>
                                <Input
                                    placeholder={placeholder}
                                    value={inputAttribute}
                                    onChange={(e) => setInputAttribute(e.target.value)}
                                    error={!!error}
                                />
                                <p className="text text-black fs-6 m-0">Confirm Password</p>
                                <Input
                                    placeholder={placeholder}
                                    value={confPasswor}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    error={!!error}
                                />
                            </div>
                        </FormControl>
                        <button
                            type="button"
                            className="btn common-button"
                            onClick={onSubmit}
                        >
                            Submit
                        </button>
                    </Stack>
                </form>
            </ModalDialog>
        </Modal >
    );
};

export default PasswordCustomModel;
